export const DEVICE_WIDTH_BREAKPOINT = 600;
